import styled from 'styled-components';
const PatchCouponStyled = styled.div`
  .main_contain {
    padding: 32px;
  }
`;
export default PatchCouponStyled;
